import React from 'react';
import {hot} from 'react-hot-loader';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import email from './email.json';

import pixImg from '../images/pix.gif';
import OptinLanding from './landing/OptinLanding';
import HealthCheck from './healthcheck/HealthCheck';
import OptinConfirmation from './optinconfirmation/OptinConfirmation';
import NotFoundPage from './notfound/NotFoundPage';

function PublicApp() {
  return (
    <Router>
      <div id="optinContentContainer" className="optinBodyText">
        <header className="header">
          <div id="optinBegin" className="centerWrap">
            <div class="header-container">
              <img src={pixImg} alt="J. P. Morgan logo" className="jpmLogo" role="presentation" />
              <span className="site-name">Virtual Card</span>
            </div>

          </div>

        </header>

        <div>
          <Switch>
            <Route path="/vce/healthcheck" component={HealthCheck} />
            <Route path="/vce/io" component={OptinLanding} />
            <Route path="/vce/ci" component={OptinConfirmation} />
            <Route component={NotFoundPage} />
          </Switch>
        </div>
      </div>

      <footer id="optinEnd" className="optinFooter">
        <div className="columnFooter">
          <div className="centerWrap">
            <h3>
              <div>
                <p>
                  <a tabIndex="4" href="http://www.jpmorgan.com/pages/privacy" title="Privacy Policy">{email.optin.ui.footer.privacy.eng}</a> | <a tabIndex="5" href="http://www.jpmorgan.com/pages/terms" title="Terms & Conditions">{email.optin.ui.footer.terms.eng}</a>
                  <span>&#169; {(new Date().getFullYear())} {email.optin.ui.footer.copyright.eng}</span>
                </p>
              </div>
            </h3>
          </div>
        </div>
      </footer>
    </Router>
  );
}

export default hot(module)(PublicApp);
